module.exports = __webpack_public_path__ + "static/media/logo_new_urgently.9bb5c0b8.svg";